<template>
  <div :class="previewMode ? '' : 'wf-border wf-p-2 wf-pt-0 wf-border-transparent hover:wf-border-gray-500 hover-trigger'">
    <div v-show="! previewMode" class="wf-relative wf-justify-end wf-flex">
      <button class="hover-target pricing-table-block-handle wf-text-gray-500"><i class="fas fa-arrows-alt"></i></button>
    </div>
    <div :class="containerClasses">
      <div
        :contenteditable="! previewMode"
        class="wf-inline-block wf-px-2 wf-py-1"
        :class="classes"
        :style="styles"
        v-text="value"
        @input="emitUpdate"
      ></div>
    </div>
  </div>
</template>

<script>
  import PricingTableBlock from '../contracts/PricingTableBlock'
  export default PricingTableBlock.extend({})
</script>